import _ from 'lodash';

const suppressOpcoList = APP_CONFIG.suppressOpcoList || '';
const suppressedOpcos = suppressOpcoList.split(',');
export const shouldCurrentOpcoSuppressed = function (opcoId) {
  return _.findIndex(suppressedOpcos, x => x === opcoId) > -1;
};
